import AbstractTemplateDetailsPage from './abstract-template-details-page';
import ProductData from '../../model/product-data';
import { formatCurrency, formatNumber } from '../../helpers/utils';

export default class WKRDetailsPage extends AbstractTemplateDetailsPage {

  private readonly saveButton: HTMLButtonElement;
  private readonly cancelButton: HTMLButtonElement | null;
  private readonly addToCartButton: HTMLButtonElement | null;

  constructor(protected container: HTMLElement) {
    super(container, (container.dataset.isOrdered !== 'true'));

    this.saveButton = container.querySelector('.js-saveButton') as HTMLButtonElement;
    this.cancelButton = container.querySelector('.js-cancelButton');
    this.addToCartButton = container.querySelector('.js-addToCartButton') as HTMLButtonElement;

    this.bindCancelButton();
    this.bindToggleButtonDisabledState();
    this.bindAddToCartSuccess();
  }

  private bindCancelButton(): void {
    this.cancelButton?.addEventListener('click', () => this.refresh()); // eslint-disable-line no-self-assign
  }

  private bindToggleButtonDisabledState(): void {
    const toggleButtonState = (e: Event) => {
      if ((e.target as HTMLInputElement).name) {
        this.enableSave();
        this.container.removeEventListener('input', toggleButtonState);
      }
    };

    this.container.addEventListener('input', toggleButtonState);
  }

  protected bindAddToCartSuccess(): void {
    $(this.container).on('addToCartSuccess', () => {
      this.refresh();
    });
  }

  protected handleRowChange(): void {
    super.handleRowChange();
    this.enableSave();
  }

  private enableSave(): void {
    this.saveButton.disabled = false;

    if (this.cancelButton) {
      this.cancelButton.classList.add('-secondary');
      this.cancelButton.classList.remove('-primary');
      this.cancelButton.disabled = false;
    }

    if (this.addToCartButton) {
      this.addToCartButton.disabled = true;
    }
  }

  protected removeAllRows(): void {
    super.removeAllRows();
    this.handleRowChange();
  }

  protected removeRow(row: HTMLTableRowElement): void {
    super.removeRow(row);
    this.handleRowChange();
  }

  protected addRow(product?: ProductData): void {
    super.addRow(product);
    this.handleRowChange();
  }

  // eslint-disable-next-line class-methods-use-this
  protected getPriceInputSelector(): string {
    return '.js-qty-selector-input';
  }

  protected recalculatePrice(): void {
    let netTotal = 0;

    Array.from(this.entriesContainer.children)
      .forEach((tr) => {
        const priceText = tr.querySelector('.js-price') as HTMLParagraphElement;
        const quantityInput = tr.querySelector('.js-qty-selector-input') as HTMLInputElement;
        const rowTotalText = tr.querySelector('.js-rowTotal') as HTMLParagraphElement;

        const rowNetTotal = Number(priceText.textContent ?? 0) * Number(quantityInput.value ?? 1);
        netTotal += rowNetTotal;
        rowTotalText.textContent = formatNumber(rowNetTotal, 2);
      });

    const taxTotal = netTotal * window.ACC.taxRate;
    const grossTotal = netTotal + taxTotal;

    this.netTotalSpan.textContent = formatCurrency(netTotal);
    this.taxTotalSpan.textContent = formatCurrency(taxTotal);
    this.grandTotalSpan.textContent = formatCurrency(grossTotal);
  }
}
